<template>
  <div class="d-flex flex-row">
    <div class="flex-item-input mr-1 border" style="flex: 1; border-radius: 4px;">
      <vue-editor
        v-if="locale === 'en'"
        v-model="en"
        :placeholder="placeholder"
        class="rich-text-editor"
        :editor-toolbar="customToolbar"
        @text-change="handleTextChange"
      />
      <vue-editor
        v-else-if="locale === 'zh'"
        v-model="zh"
        :placeholder="placeholder"
        class="rich-text-editor"
        :editor-toolbar="customToolbar"
        @text-change="handleTextChange"
      />
      <vue-editor
        v-else-if="locale === 'km'"
        v-model="km"
        :placeholder="placeholder"
        class="rich-text-editor"
        :editor-toolbar="customToolbar"
        @text-change="handleTextChange"
      />
      <vue-editor
        v-else-if="locale === 'vi'"
        v-model="vi"
        :placeholder="placeholder"
        class="rich-text-editor"
        :editor-toolbar="customToolbar"
        @text-change="handleTextChange"
      />
    </div>
    <div>
      <b-form-select
        v-model="locale"
        :options="locales"
        :style="{
          minWidth: '72px',
          width: 'auto',
          maxWidth: '120px',
        }"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
import { BFormSelect } from "bootstrap-vue";
import { VueEditor } from "vue2-editor";
import _isEqual from "lodash/isEqual";

export default {
  components: {
    BFormSelect,
    VueEditor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        en: null,
        zh: null,
        km: null,
        vi: null,
      }),
    },
    placeholder: {
      type: String,
      default: "",
    },
    initialLocale: {
      type: String,
      default: "en",
    },
  },
  watch: {
    value(newValue) {
      if (_isEqual(this.mappedReturnValue, newValue)) return;
      this.mapLocalesToData();
    },
    mappedReturnValue(newValue) {
      if (_isEqual(this.value, newValue)) return;
      this.$emit("input", newValue);
    },
  },
  data() {
    return {
      locale: this.initialLocale || "en",
      locales: [
        { value: "en", text: "English" },
        { value: "zh", text: "中文" },
        { value: "km", text: "ភាសាខ្មែរ" },
        { value: "vi", text: "Tiếng Việt" },
      ],
      en: null,
      zh: null,
      km: null,
      vi: null,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ color: [] }, { background: [] }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
    };
  },
  computed: {
    mappedReturnValue() {
      return {
        en: this.en,
        zh: this.zh,
        km: this.km,
        vi: this.vi,
      };
    },
  },
  methods: {
    handleTextChange() {
      this.$emit("input", this.mappedReturnValue);
    },
    mapLocalesToData() {
      const { en, zh, km, vi } = this.value || {};
      this.en = en || null;
      this.zh = zh || null;
      this.km = km || null;
      this.vi = vi || null;
    },
  },
  mounted() {
    this.mapLocalesToData();
  },
};
</script>

<style lang="scss" scoped>
.rich-text-editor {
  ::v-deep .ql-container {
    min-height: 100px;
    font-size: 14px;
  }
  
  ::v-deep .ql-editor {
    min-height: 100px;
  }
}
</style>

